import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './App.css';
import logo from '../src/logo.png';

function App() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [loading, setLoading] = useState(false);

  // Navbar scroll hide/show - only visible at top
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      
      // Hide if scrolled down past 100px
      if (currentScroll > 100) {
        setHideNav(true);
      } else {
        setHideNav(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (email && email.includes('@')) {
      setLoading(true);

      // EmailJS configuration
      const serviceID = 'service_58e444m';
      const templateID = 'template_cpwea89';
      const publicKey = 'Ys8hgtQa0jAEZEPHu';

      // Template parameters
      const templateParams = {
        user_email: email,
        to_name: 'Kinetix Labs',
        message: `${email}`,
      };

      try {
        await emailjs.send(serviceID, templateID, templateParams, publicKey);
        
        console.log('Email submitted successfully:', email);
        setSubmitted(true);
        setEmail('');
        setTimeout(() => setSubmitted(false), 4000);
      } catch (error) {
        console.error('EmailJS error:', error);
        alert('Something went wrong. Please try again.');
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="app">
      {/* Subtle grid background */}
      <div className="grid-bg"></div>

      {/* Logo - Upper Left */}
      <div className={`logo-container ${hideNav ? 'hide' : ''}`}>
        <img src={logo} alt="Kinetix Labs" className="logo" />
      </div>

      {/* Launch Date - Upper Right */}
      <div className={`badge-container ${hideNav ? 'hide' : ''}`}>
        <span className="badge">06/26</span>
      </div>

      {/* Main Content */}
      <main className="container">
        <div className="hero">
          <h1 className="tagline">Precision in Motion</h1>
          <p className="subtitle">
            Professional-grade automotive telemetry. <span className="highlight">No compromises.</span>
          </p>
        </div>

        {/* Features */}
        <div className="features">
          <div className="feature">
            <div className="feature-number">01</div>
            <h3 className="feature-title">Beyond GPS</h3>
            <p className="feature-desc">
              Advanced sensor fusion delivers unprecedented real-time accuracy.
            </p>
          </div>

          <div className="feature">
            <div className="feature-number">02</div>
            <h3 className="feature-title">Real Data</h3>
            <p className="feature-desc">
              Professional metrics without professional pricing.
            </p>
          </div>

          <div className="feature">
            <div className="feature-number">03</div>
            <h3 className="feature-title">Quantify Everything</h3>
            <p className="feature-desc">
              Every calculation measured with precision, tailored to your car.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="cta">
          <h2 className="cta-title">Join the Waitlist</h2>
          <form onSubmit={handleSubmit} className="form">
            <input
              type="email"
              className="input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="button" disabled={loading}>
              {loading ? 'Sending...' : 'Get Early Access'}
            </button>
          </form>
          {submitted && <p className="success">✓ You're in.</p>}
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <p>© 2026 Kinetix Labs</p>
      </footer>
    </div>
  );
}

export default App;